const translationKeys = {
  betAmount: '投注金额',
  maxBetAmountLimit: '超过最高投注限额 {{value}}',
  minBetAmountLimit: '最低投注限额为 {{value}}。',
  noBalance: '投注金额超出钱包余额',
  noAutoCashout: '需提供自动费率。',
  autoRateWarning: '自动费率应不低于',
  autoRateWarningMaxOdds: '自动费率应不超过',
  limit: '已超出限额。',
  notAchieved: '未达到要求。',
  maxBetAmount: '最高投注额',
  minBetAmount: '最低投注额',
  BET: '投注',
  PLACE_BET: '投注',
  CASH_OUT_BET: '兑现',
  WAIT: '等待',
  PLACE: '下注',
  CASHOUT_AT: '兑现倍率',
  CANCEL: '取消',
  CANCEL_BET: '取消',
  isRequired: '需提供{{label}}',
  404: '404',
  pageNotFound: '我们找不到你要找的页面！',
  error: '错误',
  somethingWentWrong: '出错了！',
  announcement_1: '游戏……后开始',
  announcement_2: '兑现倍率',
  announcement_3: '投注……后结束',
  announcement_4: '投注持续',
  BETS: '投注',
  HUBERT_TITLE: 'Hubert Hits',
  SOUND: '声音',
  MUSIC: '音乐',
  ANIMATION: '动画',
  GAME_INFO: '游戏信息',
  HOW_TO_PLAY: '怎么玩',
  GAME_RULES: '游戏规则',
  BET_HISTORY: '我的投注历史',
  LEADERBOARD: '排行榜',
  GAME_LIMIT: '游戏限额',
  BALANCE: '余额',
  WAITING_ROUND: '等待下一轮',
  ROUND_ID: '回合ID',
  ERROR_MESSAGE: '错误信息',
  ERROR_DESC: '会话已过期，或未通过访问令牌',
  GAME_LIMIT_TITLE: '游戏限额',
  MIN_BET: '最低投注额',
  MAX_BET: '最高投注额',
  MAX_WIN: '单注最高奖金',
  NO_DATA: '未找到数据',
  PLAYER: '玩家',
  MULTIPLIER: '翻倍',
  WIN: '赢',
  MY_BET: '我的投注',
  CASHOUT: '兑现',
  DATE: '日期',
  GAME_INFO_DESC: "Hubert Hits是一款有趣的多人在线爆点游戏。这是一款概率游戏，翻倍值从1.00倍开始，在爆点前不断增长到一个预先确定的随机值。游戏的目标是在爆点前兑现，以确保投注翻倍。''在繁忙的城市街道上，与这位不安分的驾驶员一起，躲避迎面而来的车辆。",
  RTP: '玩家回报率',
  GAME_VERSION: '游戏版本',
  HOW_TO_PLAY_DESC_1: '开始游戏前，请选择投注金额，点击/轻按“下注”按钮。屏幕上出现“投注已结束”信息时，才可以继续下注，或更改下一轮游戏的投注。',
  HOW_TO_PLAY_DESC_2: '当前回合的总投注额将显示在“总投注额”窗口。投注结束后，翻倍倍率显示为初始值1.00x。随后翻倍开始递增，翻倍速度从慢到快，翻倍越来越高。你可以选择一次性兑现全部金额。你的奖金将随兑现时长而增加，因此，请务必在爆点前兑现。每轮游戏以爆点结束，未兑现的资金将作废。',
  HOW_TO_PLAY_DESC_5: '你所选的兑现金额乘以当前翻倍值，就是你爆点前兑现能够赢走的金额。屏幕上显示的中奖通知将包含你的中奖金额。',
  GAME_FUNCTIONS: '游戏功能',
  BET_CASHOUT: '投注与兑现',
  HOW_TO_PLAY_DESC_6: '选择一个金额，点击“下注”。',
  HOW_TO_PLAY_DESC_7: '设置二次下注，你可以在一轮游戏中下两次注，但需要再次点击“下注”按钮，才能生效。',
  HOW_TO_PLAY_DESC_8: "更多信息，请参阅“兑现”部分。'一旦兑现，当前游戏结束，你可以开始下一轮投注。",
  RULES_DESC_1: '每次爆点时，翻倍值都会从初始值1.00x随机增加到一个预定的值。{{ value }}x是爆点的最高翻倍值。',
  PLACING_BET: '正在受理投注',
  RULES_DESC_3: '最低投注金额为{{value}},',
  RULES_DESC_3_1: '最高投注金额为{{ value }}',
  RULES_DESC_3_2: '“游戏限额”选项卡中显示默认投注倍率为{{ value }} 。',
  GAME_INDICATOR: '游戏信息图标',
  RULES_DESC_5: '如果你在投注结束后加入游戏，或者在当前回合中没有下注，屏幕会出现“等待下一轮”的信息。作为旁观者，你可以在关注当前回合，同时押注下一回合。',
  RULES_DESC_6: '当前游戏的投注如果已被受理，将显示下一轮游戏。',
  GAME_STARTS: '游戏3秒后开始',
  RULES_DESC_7: '如果你已确认投注，所有投注区域都将处于非激活状态，投注时间结束后，投注即被关闭。',
  BALANCE_INDICATOR: '余额图标',
  RULES_DESC_8: '余额图标显示你的可用资金和货币。确保你的余额足以支付投注。如果你在下注、输或赢后余额未更新，请重新开始游戏。',
  BET_INDICATOR: '总投注额图标',
  RULES_DESC_9: '总投注额图标显示当前游戏回合的总投注额。每个游戏回合都有一个ID，显示在屏幕右下方。时间图标显示当前的当地时间，例如，12:12',
  RULES_DESC_10: '如果你有任何疑问，或想联系客户服务，请提交回合ID（或截图）。',
  CASHING_OUT: '兑现',
  RULES_DESC_11: '一旦投注被受理，你就可以开始当前游戏回合。要兑现，请点击/轻按“兑现”。',
  RULES_DESC_12: 'Hubert Hits是一款实时游戏，“兑现”操作可能需要一段时间才能完成，具体取决于你的网络连接。',
  RULES_DESC_13: '当你点击/轻按“兑现”后，将启动支付请求。随后，只要未发生爆点，游戏服务器在处理该赔付请求时，将按照当前的翻倍值进行结算。',
  RULES_DESC_14: '当你选择“兑现”后，你将从游戏的所有有效投注中获得利润。随着翻倍的增加，增加的奖金也将显示在按钮上。',
  RULES_DESC_15: '如果你在爆点前点击或轻按此按钮，则会触发游戏服务器的确认程序，并根据你的请求被确认时的翻倍值，结算你的最终奖金。',
  AUTO_CASHOUT: '自动兑现',
  RULES_DESC_16: '点击屏幕上的切换按钮，在投注期间启用“自动兑现”功能。',
  RULES_DESC_18: '注意：如果所选翻倍值小于或等于爆点翻倍值，则启用自动兑现功能可确保按所选翻倍值派彩。游戏开始后，你将无法更改这些设置，但你仍然可以点击“兑现”按钮，按较小的翻倍值兑现。',
  RULES_DESC_19: '“自动游戏”预先确定游戏回合数，你可以设置自动游戏功能，重复投注。',
  RULES_DESC_20: '下注、设置自动兑现倍率，并点击或轻按“自动游戏”按钮，即可激活自动游戏功能。',
  RULES_DESC_21: '“自动游戏”窗口出现后，你只需选择重复下注的游戏回合数。根据娱乐场的管辖范围，你可能还可以访问一些其他设置。',
  RULES_DESC_22: '自动游戏将在点击或轻按“开始”按钮后激活。',
  RULES_DESC_23: '“自动游戏”期间，每一轮新游戏都将自动确认你的投注。你必须取消投注，才能更改自动兑现设置或投注额。',
  RULES_DESC_24: '要取消自动游戏，请打开“自动游戏”窗口，并点击/轻按“停止”按钮。',
  RULES_DESC_25: '在下列情况下，自动游戏功能将自动关闭：',
  RULES_DESC_26: '当所选自动游戏回合数接近零时，你将收到屏幕上的提示信息。',
  RULES_DESC_27: '自动游戏无法继续，因为余额过低。',
  RULES_DESC_28: '当余额减少、增加，或单次赢奖超过设置的值时，将触发一次或多次“停止自动游戏”。',
  RETURN_PLAYER: '玩家回报率',
  RULES_DESC_29: 'Hubert Hits的最佳理论玩家回报率为99%。',
  LAST_RESULT: '近期游戏结果',
  RULES_DESC_30: '最近几轮游戏的爆点值可在“投注”选项卡（移动端）中找到，也显示在游戏期间。你可以从菜单中找到排行榜。',
  NAVIGATION_CONTROL: '导航控制',
  RULES_DESC_34: '点击/轻按音量控制按钮，启用静音。再次点击/轻按音量控制图标，即可取消静音。',
  RULES_DESC_35: '点击/轻按菜单，查看“我的投注历史”，显示游戏活动。默认情况下，优先显示当日的游戏会话。要查看特定回合的详细信息，只需从列表中选择该回合。显示每个回合的日期、投注额、翻倍值和兑奖金额。',
  RULES_DESC_36: '点击/轻按全屏按钮，进入全屏模式。要结束该模式，请再次按住该按钮，或按键盘上的“Esc”键。',
  GAME_CONVENIENCES: '游戏异常',
  RULES_DESC_38: '如果出现技术故障，比赛将终止。所有有效兑奖保持不变，而所有未兑现的金额将予以退还。如果出现系统或软件故障，导致游戏回合取消，则将退还该回合的所有投注。',
  RULES_DESC_39: '如果你遇到任何问题，或对你的余额或投注有任何疑问，请联系客户支持中心。',
  PINGOO_TITLE: 'Pingoo Splash',
  PINGOO_GAME_INFO: "Pingoo Splash是一款有趣的多人在线爆点游戏。这是一款概率游戏，翻倍值从1.00倍开始，在爆点前不断增长到一个预先确定的随机值。游戏的目标是在爆点前兑现，以确保投注翻倍。'加入无畏的Pingoo飞行冒险之旅，躲避饥饿的虎鲸，努力飞得更高。",
  PINGOO_RULE_NAME_2: '如果你在投注结束后加入游戏，或者在当前回合中没有下注，屏幕会出现“等待下一轮”的信息。作为旁观者，你可以在关注当前回合，同时押注下一回合。',
  PINGOO_RULE_NAME_3: '一旦投注被受理，你就可以开始当前游戏回合。要兑现，请点击/轻按“兑现”。',
  PINGOO_RULE_NAME_4: '{{gameName}}是一款实时游戏，“兑现”操作可能需要一段时间才能完成，具体取决于你的网络连接。',
  PINGOO_RULE_NAME_5: '“自动游戏”期间，每一轮新游戏都将自动确认你的投注。你必须取消投注，才能更改自动兑现设置或投注额。',
  PINGOO_RULE_NAME_6: '{{gameName}} game的最佳理论玩家回报率为99%。',
  NETWORK_ERROR: '你当前为离线状态。请检查你的网络连接。',
  PLAY: '玩',
  START: '开始',
  AUTO: '自动',
  GEMX_TITLE: '宝石X',
  GEMX_GAME_INFO: '《宝石X》是一款精彩好玩的在线多人游戏，属于“爆点”游戏类型。游戏开始时，倍率从 1.00 倍开始，不断上升到一个预先设定的随机值，然后爆点。玩家必须在爆点前兑现投注，这样投注才能按当前值翻倍。翻倍不停，《宝石X》邀请玩家来考验自己的运气，看看你能否把握住正确时机。停留时间越长，风险越大，潜在赢利也越大。',
  BET_CLOSED: '投注结束',
  ACCEPT_BETS: '正在受理投注',
  WIRE_GAME_INFO: '倒计时已经开始，全球瞩目。在这款刺激的娱乐场小游戏中，你扮演的角色将决定你是赢取巨额奖金，还是彻底破产。你剪断的每一根电线都会增加你的奖金——你剪得越多，投注金额就越大。如果不小心剪到带电的电线，也别担心。真正的狠角色不会在意爆炸，只会掸掸身上的灰尘，重新开始，继续前进。',
  WIRE_GAME_INFO_1: '考验你的耐力极限，游戏共有四个强度级别：简单模式（12 根线），适合战术专家；中等难度模式（6 根线）和困难模式（4 根线）适合追求快速翻倍的玩家，而硬核模式（2 根线）则适合终极冒险家。电线越少，剪中的概率越高。无论你是保持冷静，还是大胆博弈，你的下一剪都可能改变一切。',
  WIRE_HOW_TO_PLAY_DESC_1: '选择你的风险等级：可从四个强度中选择：简单（12 根线）、中等（6 根线）、困难（4 根线）或硬核（2 根线）。',
  WIRE_HOW_TO_PLAY_DESC_2: '设定投注：选择你的投注金额——投注金额越大，每次剪线的潜在回报就越大。',
  WIRE_HOW_TO_PLAY_DESC_3: '设定投注：输入你的投注金额——投注额越高，每次剪线的潜在赔率就越大。',
  WIRE_HOW_TO_PLAY_DESC_4: '剪线：点击电线开始拆弹，或者点击“随机切断”按钮，让系统为你选择一根电线。',
  WIRE_HOW_TO_PLAY_DESC_5: '大胆博弈：点击“全部剪掉”按钮，只留一根电线，以赢得终极翻倍。',
  WIRE_HOW_TO_PLAY_DESC_6: '兑现或继续游戏：你可以随时提取奖金，也可以继续游戏，以赢取终极大奖。',
  WIRE_HOW_TO_PLAY_DESC_7: '注意引线：点击“热线”和圆形末端。别担心，重新开始游戏，再试一次。',
  WIRE_RULES_1: '每次安全剪断电线，投注都会翻倍。一旦炸弹完全拆除，你可以选择继续拆除下一颗炸弹，以进一步提高你的赢奖倍率。当前的翻倍值显示在爆炸装置的中心，此外，翻倍条将显示当前和下一个潜在的赔付值。',
  WIRE_RULES_2: '你可以点击 -/+ 按钮调整你的投注额，选择预设值，或手动输入你想要的金额。设置好投注后，按下“下注”按钮进行下注，然后开始剪线，以实现翻倍。',
  BALANCE_INDICATOR: '余额图标',
  WIRE_RULES_3: '余额图标显示你的可用资金和货币。开始投注前，请确保你的账户余额足以支付投注。如果你在下注、赢钱或输钱后，余额没有立即更新，请重新启动游戏。',
  CASHING_OUT: '兑现',
  WIRE_RULES_4: '在炸弹完全拆除前确保奖金到手，请点击或轻触“兑现”按钮。由于《火线》是一款实时游戏，请注意，“兑现”操作可能会因你的网络情况而略有延迟。',
  AUTO_PLAY_RANDOM: '自动开始游戏：随机选项',
  WIRE_RULES_5: '下注后，你可以使用特殊功能来加快拆弹速度：',
  CUT_RANDOM_1: '随机剪1条线：',
  CUT_RANDOM_2: '只留1条线：',
  WIRE_RULES_6: '此功能将随机选择并剪断一根电线。可以多次使用该功能，直到炸弹被拆除，或引爆错误的电线。',
  WIRE_RULES_7: '你将收到窗口弹出通知，你需要确认使用该高风险功能。你可以选择在同一会话的后续回合中隐藏该通知警告。',
  WIRE_INFORMATION_AND_RESULTS: '游戏信息和结果',
  WIRE_INFO_HEAD_1: '玩家回报率：',
  WIRE_INFO_HEAD_2: '近期游戏结果',
  WIRE_INFO_HEAD_3: '导航：',
  WIRE_INFO_DESC_1: ' 《火线》的理论最佳玩家回报率为 XX%。',
  WIRE_INFO_DESC_2: '最近几轮游戏的翻倍值将显示在“回合历史记录”选项卡中。',
  WIRE_INFO_DESC_3: '点击音量图标切换声音，点击菜单（汉堡）图标查看你的投注记录，点击全屏按钮扩展游戏视图。',
  TECHNICAL_ISSUES: '技术问题',
  WIRE_RULES_8: '如果出现技术故障，游戏将终止。所有有效的提款金额将保持不变，而未兑现的金额和已取消回合的下注资金将予以退还。如果你在余额或投注方面存在问题，请联系客服。',
  CASHOUT: '兑现',
  WIRE_NAME: '火线：高风险拆弹',
  WINNING_AMOUNT: '奖金金额',
  DIFFICULTY: '困难',
  YOU_CASH_OUT: '你已提现！',
  CASH_WIN: '赢奖',
  WIRE_SKIP: '点击跳过',
  WIRE_BET_WARNING: '请先\n\n\n下注',
  WIRE_LEVEL_1: '简单',
  WIRE_LEVEL_2: '中等难度',
  WIRE_LEVEL_3: '困难',
  WIRE_LEVEL_4: '硬核',
  WIRE_LEVEL_OK: '好的',
  WIRE_LEVEL_DES1: '只需剪断安全线，即可拆除炸弹。\n每次剪断安全线，都会增加你的倍率。\n剪断带电导线，\n将立即引发爆炸。\n\n',
  WIRE_LEVEL_DES2: '\n\n一根电线决定你的成败。\n努力把控局面。',
  WIRE_LEVEL_EASY: '杂乱布线：总共有 12 根电线，\n其中 1 根是“火线”。',
  WIRE_LEVEL_MEDIUM: '标准拆弹布线：5 根导线是中性线，\n1 根导线是引线。',
  WIRE_LEVEL_HARD: '高风险拆弹布线：3 根安全线，\n1 根引线。',
  WIRE_LEVEL_HARDCORE: '二选一时刻。\n引爆率五五开。',
  WIRE_LOOSE_LEVEL: '等级',
  WIRE_TRY_AGAIN: '再试一次',
  WIRE_CONTINUE: '继续',
  WIRE_CASHOUT: '兑现',
  WIRE_WIN_DES1: '你赢了',
  WIRE_WIN_DES2: '下一场胜利',
  WIRE_CUT_ALL: '是的，全部剪掉',
  WIRE_CUT_ALL_DES: '把所有电线都剪断吗？这已经无法挽回。',
  WIRE_SHOW_AGAIN: '不要再次显示',
  WIRE_CANCEL: '取消',
  WIRE_WARNING: '警告！',
  WIRE_NETWORK_ERROR: '网络错误',
  WIRE_NETWORK_ERROR_DES: '请检查你的网络\n链接并重试。',
  WIRE_LOST: '你输了',
  WIRE_BOMB_DEFUSE: '炸弹已拆除',
  WIRE_DEFUSE: '已拆除',
  WIRE_WELL_DONE: '干得好！',
  WIRE_SOUND: '爆炸声',
  MODE: '模式',
  CHANGE_MODE: '更改游戏模式',
  WIRE_MAX_MULTIPLIER: '您已达到最大倍数 {{ multiplier }}x。您的奖金已自动兑现！',
  INTERNAL_ERROR: '内部服务器错误',
  SESSION_EXPIRED: '会话已过期。请刷新以继续下注',
  INSUFFICIENT_FUNDS: '资金不足'
}

export default {
  ...translationKeys
}
